module.exports = __webpack_public_path__ + "img/logo-nsw.ba84e653.svg";